import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=2baf627c&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=js&"
export * from "./ProfileView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=2baf627c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf627c",
  null
  
)

export default component.exports